/** @todo put into shared folder to be use with play and teach */
import { initializeApp } from 'firebase/app';
import {
  doc,
  getFirestore,
  onSnapshot,
  updateDoc,
  getDoc,
  setDoc,
} from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

const firebaseConfig =
  process.env.REACT_APP_DEPLOY === "qa"
    ? {
        apiKey: "AIzaSyCSb71BhXBkKuqI5lfKfeZNPIG9MHOCois",
        authDomain: "rewriters-qa.firebaseapp.com",
        projectId: "rewriters-qa",
        storageBucket: "rewriters-qa.firebasestorage.app",
        messagingSenderId: "865230853954",
        appId: "1:865230853954:web:1cc0907ca75a12e706dadb",
      }
    : {
        apiKey: "AIzaSyDJvdd8rtWNydRSLkgVg1dgSyn3MTpo-pk",
        authDomain: "biycr-62aee.firebaseapp.com",
        projectId: "biycr-62aee",
        storageBucket: "biycr-62aee.firebasestorage.app",
        messagingSenderId: "219044721669",
        appId: "1:219044721669:web:d819c327efce4e579b186c",
      };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const auth = getAuth();

export function updateFirestoreDoc(collectionId, docId, data) {
  return updateDoc(doc(db, collectionId, docId), data).catch((error) =>
    console.error(error)
  );
}

export function getDocSnapshot(collectionId, docId, callback) {
  return onSnapshot(
    doc(db, collectionId, docId),
    (snapshot) => callback?.(snapshot),
    (error) => console.error(error)
  );
}

export function getFirestoreDoc(collectionId, docId) {
  return getDoc(doc(db, collectionId, docId)).then((docRef) => docRef.data());
}

export function setFirestoreDoc(collectionId, docId, data, options) {
  return setDoc(doc(db, collectionId, docId), data, options);
}

export function createUserEmailPassword(email, password) {
  return createUserWithEmailAndPassword(auth, email, password)
    .then(async (result) => {
      const { uid } = result.user;
      await createNewUserDoc(email, uid);
      return uid;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

async function createNewUserDoc(email, uid) {
  const user = await getFirestoreDoc('users', uid);
  if (!user) {
    return setFirestoreDoc('users', uid, {
      email,
      uid,
    });
  } else {
    return Promise.resolve();
  }
}
